// extracted by mini-css-extract-plugin
module.exports = {"item":"a10a3f92e9--item--d9uzC","name":"a10a3f92e9--name--x7_lt","value":"a10a3f92e9--value--Y34zN"};